export * from './components';
export * from './hooks';
export * from './pages';

import redux from './redux';

export default { redux };
